import { Subject } from 'rxjs/Subject';
import { BehaviorSubject } from 'rxjs/BehaviorSubject';

/**
 * @implements {IChilduppNotification}
 */
export class FCMChilduppNotification {

    constructor() {
        Object.defineProperties(this, {
            /**
             * @private
             * @property {FCMPlugin} #_fcm
             */
            _fcm: {
                value: buildFirebaseCordovaPlugin(),
            },
            /**
             * @private
             * @type {BehaviorSubject<boolean|undefined>}
             */
            _hasPermission$: {
                // When running in cordova, notification permissions are
                // granted on installation
                value: new BehaviorSubject(true),
            },
            /**
             * @private
             * @property {BehaviorSubject<string|null|undefined>} #_token$
             */
            _token$: { value: new BehaviorSubject(undefined) },
            /**
             * @private
             * @property {BehaviorSubject<IChilduppNotification~Notification>} #_notifications$
             */
            _notifications$: { value: new Subject() },
        });
        // Bind observables once fcm is ready
        this._fcm.then((fcm) => {
            /**
             * Emits the provided token via {@link #_token$}
             * @return {void}
             */
            const emitToken = (token) => {
                if (token !== this._token$.getValue()) {
                    this._token$.next(token);
                }
            };

            // Force the retrieve of the token for the first time
            fcm.getToken(emitToken);
            // Pipe fcm token refresh to our Subject
            fcm.onTokenRefresh(
                emitToken,
                () => {}, // Success registered plugin
                (error) => console.error('Error while registering FCMPlugin.onTokenRefresh', error),
            );
            // Pipe fcm notifications to our Subject
            fcm.onNotification(
                (notification) => {
                    // FIXME: FCM bug => why im getting empty notifications?
                    this._notifications$.next({
                        title: notification.title,
                        body: notification.body,
                        icon: notification.icon,
                    });
                },
                () => {},
                (error) => console.error('Error while registering FCMPlugin.onNotification', error),
            );
        });
        // If fcm initialization fails for whatever reason, emit some significative values
        this._fcm.catch((e) => {
            console.error('Couldn\'t initialzie fcm due to', e);
            this._hasPermission$.next(false);
            this._token$.next(null);
        });
    }

    /**
     * @inheritDoc
     */
    name() {
        return "FCMPlugin@" +
            window.cordova.require("cordova/plugin_list").metadata["cordova-plugin-fcm"]
    }

    /**
     * @inheritDoc
     */
    async requestPermission() {
        // When running in cordova, notification permissions are
        // granted on installation
        return Promise.resolve();
    }

    /**
     * @inheritDoc
     */
    hasPermission() {
        return this._hasPermission$.getValue();
    }

    /**
     * @inheritDoc
     */
    getToken() {
        return this._token$.getValue();
    }

    /**
     * @inheritDoc
     */
    onTokenRefresh(cb) {
        const subscription = this._token$.subscribe((token) => {
            cb(token)
        });
        return () => {
            subscription.unsubscribe();
        };
    }

    /**
     * @inheritDoc
     */
    onNotification(cb) {
        const subscription = this._notifications$.subscribe((notification) => {
            cb(notification)
        });
        return () => {
            subscription.unsubscribe();
        };
    }
}

/**
 * Prepares the firebase cloud messaging layer based on cordova-firebase-plgin. If
 * initialization fails the promise will be rejected.
 *
 * @return {FCMPlugin}
 * @see https://github.com/fechanique/cordova-plugin-fcm
 */
function buildFirebaseCordovaPlugin() {
    if (!window.FCMPlugin) {
        const err = new Error('window.FCMPlugin is not available. Check \'deviceready\' event has been fired');
        return Promise.reject(err);
    }
    return Promise.resolve(window.FCMPlugin);
}



// WEBPACK FOOTER //
// ./src/shared/childupp-notifications/fcm-childupp-notification.js